/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface FixLineItemResponseDTO
 */
export interface FixLineItemResponseDTOOptional {
  /**
   *
   * @type {string}
   * @memberof FixLineItemResponseDTO
   */
  status?: string;
}

export interface FixLineItemResponseDTO extends FixLineItemResponseDTOOptional {
  /**
   *
   * @type {string}
   * @memberof FixLineItemResponseDTO
   */
  status?: string;
}

export interface FixLineItemResponseDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof FixLineItemResponseDTO
   */
  status?: string;
  statusIsSet: boolean;
}

transformDatesMap.set(
  "FixLineItemResponseDTO",
  function (model: FixLineItemResponseDTO) {},
);

export type FixLineItemResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  status: PropertyMeta<MetaTypeBase<string>>;
}>;

export var FixLineItemResponseDTOMeta: FixLineItemResponseDTOMetaI =
  {} as FixLineItemResponseDTOMetaI;
FixLineItemResponseDTOMeta = typeMeta("FixLineItemResponseDTO", {
  status: propertyMeta("status", false, false, false, MetaTypesBase.string),
});

const metaI = FixLineItemResponseDTOMeta;

registerMeta(() => {});

export class FixLineItemResponseDTOTracked implements FixLineItemResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  status__I?: string = undefined;
  statusIsSet: boolean = false;
  set status(v: undefined | string) {
    if (v !== undefined) {
      this.status__I = v;
      this.statusIsSet = true;
    } else {
      this.status__I = v || undefined;
      this.statusIsSet = false;
    }
    this.changeTracker = true;
  }
  get status() {
    return this.status__I;
  }
  constructor(
    config?: FixLineItemResponseDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: FixLineItemResponseDTOOptional,
    options?: AssignOptions,
  ): FixLineItemResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.status && this.statusApplyFilter(optionsRequired.filter)) {
      this.status = config.status;
      if (optionsRequired.unassign) this.statusIsSet = false;
      else this.statusIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): FixLineItemResponseDTOTrackedI {
    const cloned = {} as FixLineItemResponseDTOTrackedI;
    if (
      this.statusIsSetDeep() &&
      this.statusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.statusIsSet = true;
      cloned.status = this.status;
    } else {
      //cloned.statusIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): FixLineItemResponseDTOTrackedI {
    if (!this.statusApplyFilter(filter)) this.statusIsSet = false;

    return this;
  }
  statusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      FixLineItemResponseDTOMeta.status,
      FixLineItemResponseDTOMeta,
      this.status,
      this,
    );
  }
  statusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.statusIsSet && this.statusApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.statusIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
